export function initMoreCities(btnSelector = '#show-more-cities', citySelector = '.hidden-city') {
  const btn = document.querySelector(btnSelector);
  if (btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll(citySelector).forEach(function(el) {
        if (el instanceof HTMLElement) {
          el.classList.remove('hidden-city');
        }
      });
      if (btn instanceof HTMLElement) {
        btn.style.display = 'none';
      }
    });
  }
} 